"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlaceRankDTO = void 0;
class PlaceRankDTO {
}
exports.PlaceRankDTO = PlaceRankDTO;
//# sourceMappingURL=Rank.js.map